(function () {
    const tab = UX.tab;
    const loader = {
        $activator: '',
        doi: '',
        figure: '',
        tab: '',
        references: '',
        related: '',
        details: '',
        $tabs: null,
        $spinner: null,
        figuresTab: '.figures-tab',
        tabFigure: '#pane-pcw-Figures , #pane-pcw-figures',
        referencesTab: '.references-tab',
        tabReferences: '#pane-pcw-References, #pane-pcw-references',
        relatedTab: '.related-tab',
        tabRelated: '#pane-pcw-Related, #pane-pcw-related',
        detailsTab: '.details-tab',
        accessTab: '.access-tab',
        tabDetails: '#pane-pcw-Details, #pane-pcw-details',
        vPort: 'screen-xs',
        isMobile: false,
        cloudFlareScript: '',
        openSeaDragonCloudFlareScript: '',
        init: function () {
            // show spinner
            loader.$tabs = $('.article__tab');
            loader.$spinner = $('.tab__spinner');
            loader.cloudFlareScript = $('.cloudFlareScript').length && $('.cloudFlareScript').val();
            loader.openSeaDragonCloudFlareScript =
                $('.openSeaDragonCloudFlareScript').length && $('.openSeaDragonCloudFlareScript').val();
            loader.get.figures();
            loader.get.references();
            loader.get.related();
            loader.get.details();
            loader.truncation.init();
            if ($('article')) {
                loader.load.articleTabs();
            }
            loader.tableToggle();
            loader.controller();
            loader.additionalController();
        },
        controller: function () {
            $('body').on('click', '.figures-tab', function (e) {
                loader.load.figures(true);
            });
            $('body').on('click', '.boxed-text', function (e) {
                e.preventDefault();
                const $el = $(this),
                    boxedContent = $el.attr('href'),
                    boxedHtml = $(boxedContent).html(),
                    $myModal = $('#myModal');

                if (!boxedContent || !boxedHtml) return;

                if ($myModal.length === 0) {
                    const modal_start =
                            '<div class="ux-modal-container"><div id="myModal" class="modal"><div class="modal__dialog  modal--large"><div class="modal-content">',
                        modal_header =
                            '<div class="modal__header clearfix"><button type="button" data-dismiss="modal" class="close">X</button></div>',
                        modal_body = '<div class="modal__body"></div>',
                        modal_end = '</div></div></div></div>',
                        modal = modal_start + modal_header + modal_body + modal_end;
                    $('body').append(modal);
                }

                $myModal.find('.modal__body').html(boxedHtml);
                $myModal.modal('show');
            });

            $(document).on(loader.vPort + '-on', function () {
                // Waiting for custom event that will be triggered by controller.js to activate responsive effects
                loader.isMobile = true;
                loader.rebuild.responsive();
                loader.rebuild.extra();
                loader.figures.accordion();
            });

            $(document).on(loader.vPort + '-off', function () {
                // Waiting for custom event that will be triggered by controller.js to deactivate responsive effects
                loader.isMobile = false;
                loader.rebuild.original();
                loader.figures.back();
            });

            loader.articleTabsTrigger();
        },
        additionalController: function () {},
        articleTabsTrigger: function () {
            if ($('.access-tab').length) {
                $('.access-tab').trigger('click');
            }
        },
        rebuild: {
            original: function () {
                // return loi to be as default
                var $loaWrapper = $('.loa-wrapper');
                $loaWrapper
                    .find('.accordion-tabbed__tab')
                    .removeClass('accordion-tabbed__tab')
                    .addClass('accordion-tabbed__tab-mobile');
                $loaWrapper.find('.delimiter').removeClass('hidden');
                const $author = $loaWrapper.find('.accordion-tabbed__control');
                $author.each(function () {
                    var id = $(this).attr('data-id');
                    $(this).attr('data-db-target-for', id);
                    $(this).next().attr('data-db-target-of', id).removeAttr('style');
                });
            },
            responsive: function () {
                // rebuild loi to be in selected responsive mode
                var $loaWrapper = $('.loa-wrapper');
                $loaWrapper
                    .find('.accordion-tabbed__tab-mobile')
                    .removeClass('accordion-tabbed__tab-mobile')
                    .addClass('accordion-tabbed__tab ')
                    .find('.accordion-tabbed__control')
                    .removeAttr('data-db-target-for');
                $loaWrapper
                    .find('.loa-accordion')
                    .contents()
                    .map(function () {
                        if (this.nodeType === 3) {
                            //Node.TEXT_NODE
                            $(this).wrap('<span class="delimiter hidden"></span>');
                        }
                        if ($(this).hasClass('delimiter')) {
                            $(this).addClass('hidden');
                        }
                    });
                $loaWrapper.find('.accordion-tabbed__content').removeAttr('data-db-target-of').hide();
            },
            extra: function () {},
        },
        get: {
            figures: function () {
                // get current doi
                loader.figure = $('article').attr('data-figures');
            },
            references: function () {
                // get current doi
                loader.references = $('article').attr('data-references');
            },
            related: function () {
                // get current doi
                loader.related = $('article').attr('data-related');
            },
            details: function () {
                // get current doi
                loader.details = $('article').attr('data-details');
            },
        },

        load: {
            articleTabs: function () {
                if ($(loader.figuresTab).parent('li.active').length) {
                    loader.load.figures(false, true);
                }
                loader.load.references();
                loader.load.related();
                loader.load.details();
            },
            figures: function (preventSelectActiveTab = false, onLoadtab = false) {
                // set figures pane as a target and set the requested html file
                loader.load.articleTab(
                    loader.figure,
                    loader.figuresTab,
                    loader.tabFigure,
                    'figure',
                    preventSelectActiveTab,
                    onLoadtab
                );
            },
            references: function () {
                // set references pane as a target and set the requested html file
                let $articleReferences = $('.article__body .article__references');
                // if the references exist on the body then copy it to ref tab else get it from server
                if ($articleReferences.length) {
                    if ($('.article__body.show-references').length) {
                        //copy past references
                        loader.load.copyPastReferences($articleReferences);
                    } else {
                        //cut past references
                        $articleReferences.appendTo(loader.tabReferences);
                        $articleReferences.show();
                    }
                    $(loader.tabReferences).removeClass('empty');
                    loader.$spinner.hide(); // hide spinner pane
                } else {
                    loader.load.articleTab(loader.references, loader.referencesTab, loader.tabReferences, 'references');
                }
            },
            related: function () {
                // set related pane as a target and set the requested html file
                loader.load.articleTab(loader.related, loader.relatedTab, loader.tabRelated, 'related');
                loader.truncation.creativeWorkMeta();
            },
            details: function () {
                // set details pane as a target and set the requested html file
                loader.load.articleTab(loader.details, loader.detailsTab, loader.tabDetails, 'details');
            },
            copyPastReferences: function ($articleReferences) {
                let articlesRefCopy = $articleReferences.clone();
                articlesRefCopy.appendTo(loader.tabReferences);
                $articleReferences.find('[id]').each(function () {
                    //to remove duplicate Ids
                    this.id = this.id + '_copied';
                });
            },
            articleTab(ajaxUrl, tabSelector, paneSelector, tabName, preventSelectActiveTab = false, onLoadtab = true) {
                if (ajaxUrl === undefined) {
                    // check if tab' service url has been defined
                    UX.loader.selectActiveTab(tabSelector, paneSelector, preventSelectActiveTab);
                    return false;
                }
                if (tab.check.empty($(tabSelector))) {
                    // check if tab panes is empty
                    loader.getContent(ajaxUrl, tabSelector, paneSelector, tabName, preventSelectActiveTab, onLoadtab); // get tab content
                } else {
                    UX.loader.selectActiveTab(tabSelector, paneSelector, preventSelectActiveTab);
                }
            },
        },
        getContent: function (ajaxUrl, tabSelector, paneSelector, tabName, preventSelectActiveTab = false, onLoadtab) {
            // get content using ajax request
            loader.$spinner.show(); // show spinner pane
            let $tabPane = $(paneSelector);

            $tabPane.load(ajaxUrl, {onLoad: onLoadtab}, function (response, status, xhr) {
                if (status === 'error') {
                    const msg = 'Sorry but there was an error: ';
                    console.log(msg + xhr.status + ' ' + xhr.statusText);
                }

                $tabPane.trigger('content-loaded');
                UX.loader.selectActiveTab(tabSelector, paneSelector, preventSelectActiveTab);
                loader.attach();

                const loaderTarget = $(this).attr('id'),
                    isFigures = loader.tabFigure.indexOf(loaderTarget) !== -1;
                if (isFigures && loader.isMobile) {
                    loader.figures.accordion();
                }
                loader.getContentSuccess(tabName);
            });
        },
        getContentSuccess: function (tabName) {},
        selectActiveTab(tab, tabTarget, preventSelectActiveTab) {
            UX.loader.$spinner.hide();
            if (!preventSelectActiveTab && UX.loader.isArticleTabEmpty($(tab)) && $(tabTarget).hasClass('active')) {
                $('.details-tab').trigger('click');
            }
        },
        isArticleTabEmpty($tab) {
            return (
                tab.check.empty($tab) ||
                ($tab.hasClass('figures-tab') && $($tab.data('slide-target')).find('figure').length === 0) ||
                ($tab.hasClass('references-tab') && $($tab.data('slide-target')).find('.NoContentMessage').length)
            );
        },
        attach: function () {
            if (UX.figureViewer !== undefined) UX.figureViewer.expand();
        },
        figures: {
            figcaption: 'figcaption',
            figureTitle: '.figure__title',
            figureCaption: '.figure__caption',
            accordionClass: 'accordion',
            accordionContent: 'accordion__content',
            accordionTrigger: $('<button title="Toggle figure caption" class="accordion__control"/>'),
            accordionTriggerIcon: $('<i aria-hidden="true" class="icon-section_arrow_d"/>'),
            accordionTriggerCaption: $('<span>Caption</span>'),

            accordion: function () {
                //turn figures caption into accordion on mobile
                if (!$(loader.figures.figcaption).hasClass(loader.figures.accordionClass)) {
                    loader.figures.accordionTriggerCaption.appendTo(loader.figures.accordionTrigger);
                    loader.figures.accordionTriggerIcon.appendTo(loader.figures.accordionTrigger);
                    $(loader.figures.figcaption)
                        .find(loader.figures.figureCaption)
                        .before(loader.figures.accordionTrigger);
                    $(loader.figures.figcaption).addClass(loader.figures.accordionClass);
                    $(loader.figures.figcaption)
                        .find(loader.figures.figureCaption)
                        .addClass(loader.figures.accordionContent)
                        .hide();
                }
            },
            back: function () {
                // remove accordion features on desktop
                if ($(loader.figures.figcaption).hasClass(loader.figures.accordionClass)) {
                    $('.accordion__control').remove();
                    $(loader.figures.figcaption).removeClass(loader.figures.accordionClass);
                    $(loader.figures.figcaption)
                        .find(loader.figures.figureCaption)
                        .removeClass(loader.figures.accordionContent)
                        .show();
                }
            },
        },

        truncation: {
            toTrunk8: '.loa-accordion',
            toTrunk8Mobile: '.loa.mobile-authors',
            linesToShow: 3,
            MobileLinesToShow: 3,
            showMoreText: 'See all authors',
            showLessText: 'See fewer authors',
            seeMoreIcon: 'icon-section_arrow_d',
            seeLessIcon: 'icon-section_arrow_u',
            seeMoreIconMobile: 'icon-arrow_r',

            init: function () {
                const truncateTarget = (
                    loader.isMobile ? $(loader.truncation.toTrunk8Mobile) : $(loader.truncation.toTrunk8)
                ).not("[data-truncate='none']");

                if (!truncateTarget.length && !truncateTarget.truncate) {
                    return;
                }

                if (loader.isMobile) {
                    truncateTarget.truncate({
                        lines: loader.truncation.MobileLinesToShow,
                        type: 'list',
                        seeMoreLink: true,
                        seeMoreText: loader.truncation.showMoreText,
                        seeLessText: loader.truncation.showLessText,
                        seeMoreIcon: loader.truncation.seeMoreIcon,
                        seeLessIcon: loader.truncation.seeLessIcon,
                        seeMoreIconMobile: loader.truncation.seeMoreIconMobile,
                        isMobile: true,
                        mobileTarget: '#sb-1',
                    });
                } else {
                    truncateTarget.truncate({
                        lines: loader.truncation.linesToShow,
                        type: 'list',
                        seeMoreLink: true,
                        seeMoreText: loader.truncation.showMoreText,
                        seeLessText: loader.truncation.showLessText,
                        seeMoreIcon: loader.truncation.seeMoreIcon,
                        seeLessIcon: loader.truncation.seeLessIcon,
                        seeMoreIconMobile: loader.truncation.seeMoreIconMobile,
                    });
                }
            },
            creativeWorkMeta: function () {
                const truncateTarget = $('.creative-work .meta').not("[data-truncate='none']");
                if (!truncateTarget.length) {
                    return;
                }
                truncateTarget.truncate({
                    lines: 1,
                });
            },
        },
        tableToggle: function () {
            var $triggers = $('.tableToggle__trigger');
            if ($triggers.length) {
                $triggers.on('click', function (event) {
                    var $target = $(event.currentTarget),
                        $tableToggle = $target.closest('.tableToggle');

                    $tableToggle.find('.tableToggle__table').toggle();
                    $tableToggle.find('.tableToggle__image').toggle();
                    $target.find('span').toggle();
                });
            }
        },
    };

    UX.loader = loader; // add to global namespace
})();
